/* eslint-disable react/forbid-prop-types */
import React, { Component } from 'react';
import { ComboBox, DropdownSkeleton } from 'carbon-components-react';
import PropTypes from 'prop-types';
import AuditRepository from '../../../helpers/api/AuditRepository';

export default class AuditRemoteComboBox extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      items: []
    };
    this.onChange = this.onChange.bind(this);
    this.repository = new AuditRepository();
  }

  async componentDidMount() {
    this.setState({ loading: true });
    const items = await this.getItems();
    this.setState({ items, loading: false });
  }

  onChange = (selectedItem) => {
    const item = selectedItem ? selectedItem.selectedItem : null;
    this.props.onChange(item);
  };

  getItems = async () => {
    let items = [{id: 'Yes', name: 'Yes', value: 'true'}, {id: 'No', name: 'No', value: 'false'}];
    return items;
  };

  render() {
    return this.state.loading ? (
      <DropdownSkeleton />
    ) : (
      <ComboBox
        id="cmbAuditRemote"
        disabled={this.state.items < 1 || this.props.disabled}
        placeholder="All"
        items={this.state.items}
        onChange={this.onChange}
        shouldFilterItem={({ item, inputValue }) =>
          item.name?.toLowerCase().includes(inputValue?.toLowerCase())
        }
        itemToString={(item) => (item ? item && item.name : '')}
        initialSelectedItem={this.props.initialSelectedItem}
      />
    );
  }
}

AuditRemoteComboBox.propTypes = {
  onChange: PropTypes.func.isRequired,
  onError: PropTypes.func.isRequired,
  initialSelectedItem: PropTypes.object,
  disabled: PropTypes.bool
};
AuditRemoteComboBox.defaultProps = {
  initialSelectedItem: null,
  disabled: true
};
